const initBlock = function( $block ) {
	const vacancyModals = () => {
		const $modalBtn = $block.find( '.career-item__button' );
		if ( !$modalBtn.length ) {
			return false;
		}

		$modalBtn.on( 'click', function( e ) {
			e.preventDefault();
			const $this = $( this );
			const vacancyID = $this.attr( 'data-vacancy-id' );

			const $modalVacancy = $( '#modal-careers' );
			const $modalContent = $modalVacancy.find( '.modal-careers__content' );
			const $spinner = $modalVacancy.find( '.loading-spinner-wrap' );
			const $modalContentWrapper = $modalVacancy.find( '.modal-content' );

			$modalContentWrapper.hide();
			$spinner.show();
			$modalVacancy.modal( 'show' );

			$.ajax( {
				url: window.vacancyAjaxParams.ajax_url,
				type: 'POST',
				data: {
					action: window.vacancyAjaxParams.ajax_action,
					nonce: window.vacancyAjaxParams.nonce,
					vacancyId: vacancyID
				},
				success: function( response ) {
					if ( response.success ) {
						const vacancyPopupHTML = response.data;
						$modalContent.html( vacancyPopupHTML );
						$spinner.hide();
						$modalContentWrapper.fadeIn( 100 );
					} else {
						console.error( response.data );
						$spinner.hide();
					}
				},
				error: function( xhr, status, error ) {
					console.error( 'AJAX error:', error );
					$spinner.hide();
				},
			} );
		} );
	};
	vacancyModals();
};

app.loadBlock( initBlock, 'section-careers', '.section-careers' );

if ( module.hot ) {
	module.hot.accept();
}
